/* eslint-disable camelcase */

import { makeAutoObservable, set } from 'mobx'

class Form {
  id = 0
  equipment_id = 0

  code = ''
  name = ''
  created = null
  modified = null

  constructor (data) {
    makeAutoObservable(this)
    set(this, data)
  }
}

export default Form
